import { defineMessages } from '../define';

/** Sidebar, topbar, account menu and the command palette. */
export const nav = defineMessages({
  en: {
    'nav.group.monitor': 'Monitor',
    'nav.group.automate': 'Automate',
    'nav.group.administer': 'Administer',

    'nav.overview': 'Overview',
    'nav.sessions': 'Sessions',
    'nav.inbox': 'Live inbox',
    'nav.chats': 'Chats',
    'nav.contacts': 'Contacts',
    'nav.webhooks': 'Webhooks',
    'nav.keywords': 'Keywords',
    'nav.ai': 'AI analysis',
    'nav.notifications': 'Notifications',
    'nav.apiKeys': 'API keys',
    'nav.users': 'Users',
    'nav.roles': 'Roles',
    'nav.logs': 'Logs',
    'nav.audit': 'Audit trail',
    'nav.settings': 'Settings',

    'nav.attention.one': '{count} session needs attention',
    'nav.attention.other': '{count} sessions need attention',
    'nav.live': '{count} live',
    'nav.newSession': 'New session',
    'nav.open': 'Open navigation',
    'nav.hideSidebar': 'Hide sidebar',
    'nav.showSidebar': 'Show sidebar',

    'topbar.search': 'Search or jump to…',
    'topbar.connection.idle': 'Offline',
    'topbar.connection.connecting': 'Connecting',
    'topbar.connection.connected': 'Live',
    'topbar.connection.reconnecting': 'Reconnecting',
    'topbar.connection.failed': 'Disconnected',
    'topbar.connection.liveHint': 'Receiving live updates',
    'topbar.connection.pausedHint':
      'Live updates are paused — the page will catch up when the connection returns',

    'account.appearance': 'Appearance',
    'account.theme.light': 'Light',
    'account.theme.dark': 'Dark',
    'account.theme.system': 'Match system',
    'account.language': 'Language',
    'account.signOut': 'Sign out',

    'palette.label': 'Command palette',
    'palette.placeholder': 'Search sessions, pages and actions…',
    'palette.empty': 'Nothing matches that.',
    'palette.pages': 'Pages',
    'palette.sessions': 'Sessions',
    'palette.actions': 'Actions',
    'palette.newSession': 'Connect a new LINE account',
  },
  th: {
    'nav.group.monitor': 'เฝ้าติดตาม',
    'nav.group.automate': 'ระบบอัตโนมัติ',
    'nav.group.administer': 'ดูแลระบบ',

    'nav.overview': 'ภาพรวม',
    'nav.sessions': 'เซสชัน',
    'nav.inbox': 'กล่องข้อความสด',
    'nav.chats': 'แชท',
    'nav.contacts': 'รายชื่อผู้ติดต่อ',
    'nav.webhooks': 'Webhooks',
    'nav.keywords': 'คำสำคัญ',
    'nav.ai': 'วิเคราะห์ด้วย AI',
    'nav.notifications': 'การแจ้งเตือน',
    'nav.apiKeys': 'API keys',
    'nav.users': 'ผู้ใช้',
    'nav.roles': 'บทบาท',
    'nav.logs': 'บันทึกระบบ',
    'nav.audit': 'ประวัติการใช้งาน',
    'nav.settings': 'ตั้งค่า',

    'nav.attention.one': 'มี {count} เซสชันที่ต้องตรวจสอบ',
    'nav.attention.other': 'มี {count} เซสชันที่ต้องตรวจสอบ',
    'nav.live': 'ออนไลน์ {count}',
    'nav.newSession': 'สร้างเซสชันใหม่',
    'nav.open': 'เปิดเมนู',
    'nav.hideSidebar': 'ซ่อนเมนูด้านข้าง',
    'nav.showSidebar': 'แสดงเมนูด้านข้าง',

    'topbar.search': 'ค้นหาหรือข้ามไปยัง…',
    'topbar.connection.idle': 'ออฟไลน์',
    'topbar.connection.connecting': 'กำลังเชื่อมต่อ',
    'topbar.connection.connected': 'สด',
    'topbar.connection.reconnecting': 'กำลังเชื่อมต่อใหม่',
    'topbar.connection.failed': 'ขาดการเชื่อมต่อ',
    'topbar.connection.liveHint': 'กำลังรับข้อมูลแบบเรียลไทม์',
    'topbar.connection.pausedHint':
      'การอัปเดตแบบเรียลไทม์หยุดชั่วคราว — หน้าจะอัปเดตให้ทันทีเมื่อเชื่อมต่อได้อีกครั้ง',

    'account.appearance': 'ธีม',
    'account.theme.light': 'สว่าง',
    'account.theme.dark': 'มืด',
    'account.theme.system': 'ตามระบบ',
    'account.language': 'ภาษา',
    'account.signOut': 'ออกจากระบบ',

    'palette.label': 'แถบคำสั่ง',
    'palette.placeholder': 'ค้นหาเซสชัน หน้า และคำสั่ง…',
    'palette.empty': 'ไม่พบรายการที่ตรงกัน',
    'palette.pages': 'หน้า',
    'palette.sessions': 'เซสชัน',
    'palette.actions': 'การทำงาน',
    'palette.newSession': 'เชื่อมต่อบัญชี LINE ใหม่',
  },
});
